// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EPxwR{display:flex;flex-direction:column;gap:16px;margin-bottom:12px}.SfNDw{display:flex;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceRateForm": `EPxwR`,
	"serviceRateContainer": `SfNDw`
};
export default ___CSS_LOADER_EXPORT___;
